module.exports = __webpack_public_path__ + "static/img/print.24fdcfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CloudQuickPrinting/print.png
// module id = xZcQ
// module chunks = 10